import { ExternalLookupTypeDTO } from '@/api/base/DTOs';
import { ExternalLookupType } from '@/typings';

export const adaptExternalLookupTypeToExternalLookupTypeResponse = (
  externalLookupType: ExternalLookupType,
): ExternalLookupTypeDTO => {
  switch (externalLookupType) {
    case ExternalLookupType.None:
      return ExternalLookupTypeDTO.None;
    case ExternalLookupType.Address:
      return ExternalLookupTypeDTO.Address;
    case ExternalLookupType.CityStateCountry:
      return ExternalLookupTypeDTO.CityStateCountry;
    case ExternalLookupType.Facility:
      return ExternalLookupTypeDTO.Facility;
    case ExternalLookupType.License:
      return ExternalLookupTypeDTO.License;
    case ExternalLookupType.Education:
      return ExternalLookupTypeDTO.Education;
    case ExternalLookupType.BoardCertification:
      return ExternalLookupTypeDTO.BoardCertification;
    case ExternalLookupType.DEALicense:
      return ExternalLookupTypeDTO.DEALicense;
    case ExternalLookupType.FacilityAddress:
      return ExternalLookupTypeDTO.FacilityAddress;
  }
};
